import axios from 'axios'
// import { STORE_REQUEST, STORE_LOADING_STOP } from '@/store/types'
import { AUTH_LOGOUT } from '@/store/types'

import router from '@/router'
import { baseUri } from './constants'
import vuexStore from '@/store'
import i18n from '@/i18n'

const transAccessStoreKey =
  window.location.host.indexOf('www-devqa') >= 0
    ? 'www-devqa.campusbook.co.kr'
    : 'www.campusbook.co.kr'
const instance = axios.create({
  baseURL: baseUri,
  headers: {
    'Access-ealice-store':
      window.location.host === 'localhost:8080'
        ? 'www-devqa.campusbook.co.kr'
        : transAccessStoreKey
  }
  // headers: {
  //   'Access-ealice-store':
  //     window.location.host === 'localhost:8080'
  //       ? 'www-devqa.campusbook.co.kr'
  //       : window.location.host
  // }
})

instance.interceptors.request.use(
  (config) => {
    // vuexStore.commit(STORE_REQUEST)
    let token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    // vuexStore.commit(STORE_LOADING_STOP)
    return Promise.reject(error)
  }
)

instance.interceptors.request.use(
  (config) => {
    let i18nlocale = i18n.locale
    // vuexStore.commit(STORE_REQUEST)

    if (i18nlocale) {
      config.headers['Access-ealice-i18n'] = i18nlocale
    }
    return config
  },
  (error) => {
    // vuexStore.commit(STORE_LOADING_STOP)
    return Promise.reject(error)
  }
)

// Route to 404 when not found
instance.interceptors.response.use(
  (response) => {
    // vuexStore.commit(STORE_LOADING_STOP)
    return response
  },
  (error) => {
    // vuexStore.commit(STORE_LOADING_STOP)
    if (error.response.status === 404) {
      router.push({ name: '404' })
    }

    if (error.response.status === 401) {
      if (localStorage.getItem('token')) {
        localStorage.removeItem('token')
      }

      // router.app._route.name !== 'store'
      vuexStore.commit(AUTH_LOGOUT)
      router.app._route.matched[0].meta.requiresAuth &&
        router.push({ name: 'login' })
    }

    return Promise.reject(error)
  }
)

export default instance
